import { render, staticRenderFns } from "./SaveNomenclature.vue?vue&type=template&id=d129165e&"
import script from "./SaveNomenclature.vue?vue&type=script&lang=js&"
export * from "./SaveNomenclature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports